import { render } from "./ModalBase.vue?vue&type=template&id=44c31ba2&scoped=true"
import script from "./ModalBase.vue?vue&type=script&lang=js"
export * from "./ModalBase.vue?vue&type=script&lang=js"

import "./ModalBase.vue?vue&type=style&index=0&id=44c31ba2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44c31ba2"]])

export default __exports__